var exports = {
  "x": "ActivityPiPContent.module__window___emhwdX",
  "Zp": "ActivityPiPContent.module__layout___emhwdX",
  "wx": "ActivityPiPContent.module__header___emhwdX",
  "qr": "ActivityPiPContent.module__footer___emhwdX",
  "UU": "ActivityPiPContent.module__name___emhwdX",
  "QS": "ActivityPiPContent.module__mine___emhwdX",
  "aY": "ActivityPiPContent.module__headerButton___emhwdX",
  "nr": "ActivityPiPContent.module__headerIcon___emhwdX",
  "rf": "ActivityPiPContent.module__body___emhwdX",
  "Av": "ActivityPiPContent.module__keysDot___emhwdX",
  "W5": "ActivityPiPContent.module__keysDotActive___emhwdX",
  "_n": "ActivityPiPContent.module__keysText___emhwdX",
};

module.exports = exports;
